import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConditionalIcon } from 'foundations-assets/icons/components/ConditionalIcon';
import { FileIcon } from 'foundations-assets/icons/components/FileIcon';
import { LessonIcon } from 'foundations-assets/icons/components/LessonIcon';
import { getPluginRegistry } from 'breeze-artifacts-sdk/registry';
import { jsx as _jsx } from "react/jsx-runtime";
// Temporary: types that have not registered a plugin yet. Delete each entry
// once its type registers an icon/label, so the registry lookup takes over.
const UNREGISTERED_TYPE_DISPLAY_SHIM = {
  LANDING_PAGE: {
    icon: /*#__PURE__*/_jsx(LessonIcon, {
      size: "200"
    }),
    translatedLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "artifacts.chip.type.landingPage"
    })
  },
  BLOG_POST: {
    icon: /*#__PURE__*/_jsx(LessonIcon, {
      size: "200"
    }),
    translatedLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "artifacts.chip.type.blogPost"
    })
  },
  SITE_PAGE: {
    icon: /*#__PURE__*/_jsx(LessonIcon, {
      size: "200"
    }),
    translatedLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "artifacts.chip.type.sitePage"
    })
  },
  FORMS_CONDITIONAL_LOGIC: {
    icon: /*#__PURE__*/_jsx(ConditionalIcon, {
      size: "200"
    }),
    translatedLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "artifacts.chip.type.formsConditionalLogic"
    })
  }
};

/**
 * Shared so the canvas Dynamic Artifact chip resolves a referenced artifact's
 * icon + label through the exact same registry lookup as the artifact chip.
 */
export function getArtifactChipDisplay(artifactType) {
  var _UNREGISTERED_TYPE_DI;
  const plugin = getPluginRegistry().get(artifactType);
  if (plugin !== null && plugin !== void 0 && plugin.icon) {
    const Icon = plugin.icon;
    return {
      icon: /*#__PURE__*/_jsx(Icon, {
        size: "200"
      }),
      translatedLabel: plugin.label
    };
  }
  return (_UNREGISTERED_TYPE_DI = UNREGISTERED_TYPE_DISPLAY_SHIM[artifactType]) !== null && _UNREGISTERED_TYPE_DI !== void 0 ? _UNREGISTERED_TYPE_DI : {
    icon: /*#__PURE__*/_jsx(FileIcon, {
      size: "200"
    }),
    translatedLabel: artifactType
  };
}